// extracted by mini-css-extract-plugin
export default {"title":"Intro_title__liiHU","bottomTitle":"Intro_bottomTitle__SS4T0"};